import React, { useEffect, useState } from 'react';
import {  Nav,  Badge, Dropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { TbMapSearch } from "react-icons/tb";
import { TfiDashboard } from "react-icons/tfi";
import { MdAssignmentAdd } from "react-icons/md";
import { MdHistory } from "react-icons/md";
import { FaEdit } from "react-icons/fa";
import { CgMenuGridR } from "react-icons/cg";
import { FaMoneyBillTransfer } from "react-icons/fa6";

import {
  PackageIcon,
  AnalyticsIcon,
  FolderIcon,
  UserIcon,
  PencilIcon,
} from '../../static/icons/navicons.js';
import { useSelector, useDispatch } from 'react-redux';
import { logout } from '../../redux/slice/auth/user-slice';

import './index.css';

const NavBarSiderCard = ({ user }) => {
  const dispatch = useDispatch();
  const [activeLink, setActiveLink] = useState(0);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleLogout = () => {
    dispatch(logout());
  };

  const custNav = [
    { text: 'Analytics', link: '/analytics', icon: <AnalyticsIcon className="h-5 w-5" /> },
    { text: 'Dashboard', link: '/dashboard', icon: <TfiDashboard className="h-5 w-5" /> },
    { text: 'Create', link: '/create-shipment', icon: <PencilIcon className="h-5 w-5" /> },
    { text: 'Shipments', link: '/all-shipments', icon: <PackageIcon className="h-5 w-5" /> },
    { text: 'Track', link: '/track', icon: <TbMapSearch className="h-5 w-5" />},
    { text: 'Payments', link: '/payments', icon: <FaMoneyBillTransfer className="h-5 w-5" /> },
    {
      text: 'Account',
      dropdownItems: ['Logout'],
      to: '/login',
      icon: <UserIcon className="h-5 w-5" />,
    },
  ];

  const adminNav = [
    { text: 'Analytics', link: '/analytics', icon: <AnalyticsIcon className="h-5 w-5" /> },
    { text: 'Dashboard', link: '/dashboard', icon: <TfiDashboard className="h-5 w-5" /> },
    { text: 'Requests', link: '/manage-users', icon: <FolderIcon className="h-5 w-5" /> },
    { text: 'Assign', link: '/process-shipments', icon: <MdAssignmentAdd className="h-5 w-5" /> },
    { text: 'Update', link: '/update-status', icon: <FaEdit className="h-5 w-5" /> },
    { text: 'Shipments', link: '/all-shipments', icon: <PackageIcon className="h-5 w-5" /> },
    { text: 'Track', link: '/track', icon: <TbMapSearch className="h-5 w-5" /> },
    { text: 'Payments', link: '/payments', icon: <FaMoneyBillTransfer className="h-5 w-5" /> },
    {
      text: 'Account',
      dropdownItems: ['Logout'],
      to: '/login',
      icon: <UserIcon className="h-5 w-5" />,
    },
  ];

  const riderNav = [
    { text: 'Analytics', link: '/analytics', icon: <AnalyticsIcon className="h-5 w-5" /> },
    { text: 'Dashboard', link: '/dashboard', icon: <TfiDashboard className="h-5 w-5" /> },
    { text: 'Update', link: '/update-status', icon: <FaEdit className="h-5 w-5" /> },
    { text: 'History', link: '/history', icon: <MdHistory className="h-5 w-5" /> },
    {
      text: 'Account',
      dropdownItems: ['Logout'],
      to: '/login',
      icon: <UserIcon className="h-5 w-5" />,
    },
  ];

  const navLinks = user.role === 'vendor' ? custNav : user.role === 'admin' ? adminNav : user.role === 'rider' ? riderNav: [];

  useEffect(() => {}, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <div style={{ minHeight: '94vh'}} className='bg-dark'>
      <div className="mobile-menu-toggle d-md-none text-light " style={{width:"40px"}} onClick={toggleMobileMenu}>
        {isMobileMenuOpen ? 'Close Menu' : <CgMenuGridR className="h-10 w-10 p-1 mt-20"/>}
      </div>
      {isMobileMenuOpen && (
        <div className="overlay-menu position-fixed top-0 start-0 w-100 h-100 bg-dark text-light" style={{ zIndex: 1050 }}>
          <div className="menu-close text-end p-3">
            <button className="btn btn-light" onClick={toggleMobileMenu}>
              Close
            </button>
          </div>
          <div className="menu-content p-4">
            {navLinks.map((item, index) => (
              <React.Fragment key={index}>
                <Link
                  to={item.link}
                  className={`navbar-link px-2 text-decoration-none rounded ${
                    activeLink === index ? 'cust-nav-active-link' : ''
                  }`}
                  onClick={() => {
                    setActiveLink(index);
                    toggleMobileMenu();
                  }}
                >
                  {item.dropdownItems ? (
                    <Dropdown>
                      <Dropdown.Toggle as={Nav.Link} className="p-0 custom-dropdown-toggle">
                        <div className="flex gap-3 items-center">
                          {item.icon && item.icon}
                          <span className="text-light">{item.text}</span>
                          {item.badge && (
                            <Badge className="bg-primary ml-auto rounded-circle p-1">{item.badge}</Badge>
                          )}
                        </div>
                      </Dropdown.Toggle>
                      {item.dropdownItems && item.dropdownItems.length > 0 && (
                        <Dropdown.Menu className="py-1 w-25">
                          {item.dropdownItems.map((dropdownItem, subIndex) => (
                            <Dropdown.Item key={subIndex}>
                              <Link
                                to={item.to}
                                className="text-decoration-none"
                                onClick={handleLogout}
                              >
                                {dropdownItem}
                              </Link>
                            </Dropdown.Item>
                          ))}
                        </Dropdown.Menu>
                      )}
                    </Dropdown>
                  ) : (
                    <div className="flex gap-3 items-center">
                      {item.icon && item.icon}
                      <span className="text-light">{item.text}</span>
                      {item.badge && (
                        <Badge className="bg-primary ml-auto rounded-circle p-1">{item.badge}</Badge>
                      )}
                    </div>
                  )}
                </Link>
                <hr className="my-2 text-light" />
              </React.Fragment>
            ))}
          </div>
        </div>
      )}
      <div className="d-none d-md-block nav-sider-card h-100 bg-dark" style={{ minHeight: '94vh'}}>
        <div className="menu-content rounded-0 p-4 pe-2 pt-1">
          <div className="flex flex-col p-0 gap-2 text-md font-medium pe-4 mt-20">
            <br />
            <br />
            {navLinks.map((item, index) => (
              <React.Fragment key={index}>
                <Link
                  to={item.link}
                  className={`navbar-link px-2 text-decoration-none rounded ${
                    activeLink === index ? 'cust-nav-active-link' : ''
                  }`}
                  onClick={() => setActiveLink(index)}
                >
                  {item.dropdownItems ? (
                    <Dropdown>
                      <Dropdown.Toggle as={Nav.Link} className="p-0 custom-dropdown-toggle">
                        <div className="flex gap-3 items-center">
                          {item.icon && item.icon}
                          <span className="text-light">{item.text}</span>
                          {item.badge && (
                            <Badge className="bg-primary ml-auto rounded-circle p-1">{item.badge}</Badge>
                          )}
                        </div>
                      </Dropdown.Toggle>
                      {item.dropdownItems && item.dropdownItems.length > 0 && (
                        <Dropdown.Menu className="py-1 w-25">
                          {item.dropdownItems.map((dropdownItem, subIndex) => (
                            <Dropdown.Item key={subIndex}>
                              <Link
                                to={item.to}
                                className="text-decoration-none"
                                onClick={handleLogout}
                              >
                                {dropdownItem}
                              </Link>
                            </Dropdown.Item>
                          ))}
                        </Dropdown.Menu>
                      )}
                    </Dropdown>
                  ) : (
                    <div className="flex gap-3 items-center">
                      {item.icon && item.icon}
                      <span className="text-light">{item.text}</span>
                      {item.badge && (
                        <Badge className="bg-primary ml-auto rounded-circle p-1">{item.badge}</Badge>
                      )}
                    </div>
                  )}
                </Link>
                <hr className="my-2 text-light" />
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NavBarSiderCard;
